export default "__VITE_ASSET__CNX4BX21__"